import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../api/snackbarSlice';

export function useActionDeniedSnackbar() {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(
      showSnackbar({
        severity: 'error',
        variant: 'access_denied',
        templateKey: 'action_denied',
      }),
    );
  }, [dispatch]);
}
